module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAhFBMVEUAAADtqLD///9dXV0AAACioqLgaHXOESbQHDD54OPz8/MhISEMDAze3t799PXUMELYQ1T++frJyckGBgY2Njb5+fn1zdHPFyvkfoqKiop1dXXpkpvxvMJISEi3t7fcVGPTJzr76+3n5+cVFRUYGBjq6ur66evSJTjVNUfY2NgnJyf4294+NnS0AAAAAXRSTlMAQObYZgAAAG5JREFUeAGdyEUCg0AQBEDoFdwdFojr/98Xz8wxUseyvmBDSAXtPN3C9fwgjOKEwkmzvCiruqFwWnSyx8DhGIxywsyxWK7Wm+1uT+HMmOQIw+EM6GWHlqOpq7LIs5TCOcTH8OSfXQpHQ0kB2/rDFRxFB4Hm7rIwAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/TT.png
// module id = 1286
// module chunks = 0